export default __webpack_public_path__ + "images/044be9efbfd8c12ba32fd9d33eb06f22.png";